import { Validators } from '@angular/forms';
import { CustomValidators } from './custom-validators';

export class PasswordValidators {
    static MIN_LENGTH = 8;
    static MAX_LENGTH = 72;

    static main() {
        return [
          Validators.required,
            Validators.minLength(PasswordValidators.MIN_LENGTH),
            Validators.maxLength(PasswordValidators.MAX_LENGTH),
            CustomValidators.numbersAndLetters,
            CustomValidators.upperLowerCases,
        ];
    }
}
